import React, { lazy } from "react";

const Monitor = lazy(() => import("./index"));
const SignalData = lazy(() => import("./signal-data"));
const HistoricalRuns = lazy(() => import("./historical-runs"));
const LiveServices = lazy(() => import("./live-services"));
const AdvancedControllers = lazy(() => import("./advanced-controller"));
const VirtualSensor = lazy(() => import("./virtual-sensor"));
const RunDetails = lazy(() => import("./run-details"));
const TrendReports = lazy(() => import("./trend-reports"));
const CompareProducts = lazy(() => import("./compare-products"));

const MonitorRoute = () => {
    return [
        {
            key: "scada2",
            path: "/live_data/scada2",
            component: <SignalData />,
        },
        {
            key: "scada1",
            path: "/live_data/scada1",
            component: <SignalData />,
        },
        {
            key: "monitormodels",
            path: "/live_historical_data/monitormodels",
            component: <Monitor />,
        },
        {
            key: "historical_runs",
            path: "/live_historical_data/historical_runs",
            component: <HistoricalRuns />,
        },
        {
            key: "trend_reports",
            path: "/live_historical_data/trend_reports",
            component: <TrendReports />,
        },
        {
            key: "compare_products",
            path: "/live_historical_data/compare_products",
            component: <CompareProducts />,
        },
        {
            key: "runs",
            path: "/facility/:facilityId/runs/:runId",
            component: <RunDetails />,
        },
        {
            key: "live_services",
            path: "/live_historical_data/live_services",
            component: <LiveServices />,
        },
        {
            key: "advanced_controller",
            path: "/live_historical_data/advanced_controllers",
            component: <AdvancedControllers />,
        },
        {
            key: "virtual_sensor",
            path: "/live_historical_data/virtual_sensor",
            component: <VirtualSensor />,
        },
    ];
};

export default MonitorRoute;
